import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowTrendDown = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 12,
	height: 16,
	viewBox: "0 0 12 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M2.04375 9.13437C2.19375 8.98437 2.375 8.91237 2.5875 8.91837C2.8 8.92487 2.98125 9.00312 3.13125 9.15312L5.25 11.2719L5.25 2.90937C5.25 2.69687 5.322 2.51862 5.466 2.37462C5.6095 2.23112 5.7875 2.15937 6 2.15937C6.2125 2.15937 6.39075 2.23112 6.53475 2.37462C6.67825 2.51862 6.75 2.69687 6.75 2.90937L6.75 11.2719L8.8875 9.13438C9.0375 8.98438 9.21575 8.90937 9.42225 8.90937C9.62825 8.90937 9.80625 8.98438 9.95625 9.13438C10.1063 9.28438 10.1813 9.46262 10.1813 9.66912C10.1813 9.87512 10.1063 10.0531 9.95625 10.2031L6.525 13.6344C6.45 13.7094 6.36875 13.7626 6.28125 13.7941C6.19375 13.8251 6.1 13.8406 6 13.8406C5.9 13.8406 5.80625 13.8251 5.71875 13.7941C5.63125 13.7626 5.55 13.7094 5.475 13.6344L2.025 10.1844C1.8875 10.0469 1.81875 9.87512 1.81875 9.66912C1.81875 9.46262 1.89375 9.28437 2.04375 9.13437Z",
		fill: "black"
	})
});
export default SvgArrowTrendDown;
